import React from 'react';
import Reveal from './Reveal';
import { INSTITUTIONAL_INFO } from '../constants';

const About: React.FC = () => {
    return (
        <section id="quem-somos" className="py-24 bg-white overflow-hidden">
            <div className="container mx-auto px-4">
                <div className="flex flex-col lg:flex-row gap-16 items-center">
                    <div className="lg:w-1/2 relative">
                        <Reveal>
                            <div className="relative z-10 rounded-2xl overflow-hidden shadow-2xl transform lg:rotate-2 hover:rotate-0 transition-all duration-500 will-change-transform img-shine group">
                                <img
                                    src="assets/mesa.webp"
                                    alt="Reunião ACONTURS"
                                    className="w-full h-auto group-hover:scale-105 transition-transform duration-700"
                                />
                                <div className="absolute inset-0 bg-gradient-to-tr from-brand-green/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none"></div>
                            </div>
                        </Reveal>
                        {/* OTIMIZAÇÃO: Substituição de Blur por Gradient */}
                        <div className="absolute -bottom-8 -right-8 w-64 h-64 bg-[radial-gradient(circle,rgba(254,193,14,0.3)_0%,rgba(0,0,0,0)_70%)] pointer-events-none z-0"></div>
                        <div className="absolute -top-8 -left-8 w-64 h-64 bg-[radial-gradient(circle,rgba(0,104,55,0.2)_0%,rgba(0,0,0,0)_70%)] pointer-events-none z-0"></div>
                    </div>

                    <div className="lg:w-1/2">
                        <Reveal delay={200}>
                            <div className="text-brand-green font-bold tracking-widest uppercase text-sm mb-4 block">
                                Sobre a Associação
                            </div>
                            <h2 className="text-3xl md:text-4xl font-extrabold text-brand-darkGreen mb-6 leading-tight">
                                {INSTITUTIONAL_INFO.fullTitle}
                            </h2>
                        </Reveal>

                        <Reveal delay={400}>
                            <div className="text-slate-600 text-lg mb-8 leading-relaxed">
                                <p>{INSTITUTIONAL_INFO.description}</p>
                            </div>
                        </Reveal>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                            <Reveal delay={600}>
                                <div className="p-6 rounded-xl bg-slate-50 border-l-4 border-brand-green">
                                    <h3 className="font-bold text-brand-darkGreen mb-2 flex items-center gap-2">
                                        <i className="fas fa-bullseye"></i>
                                        Nossa Missão
                                    </h3>
                                    <div className="text-slate-600 text-sm leading-relaxed">
                                        <p>{INSTITUTIONAL_INFO.mission}</p>
                                    </div>
                                </div>
                            </Reveal>

                            <Reveal delay={800}>
                                <div className="p-6 rounded-xl bg-slate-50 border-l-4 border-brand-yellow">
                                    <h3 className="font-bold text-brand-darkGreen mb-2 flex items-center gap-2">
                                        <i className="fas fa-eye"></i>
                                        Nossa Visão
                                    </h3>
                                    <div className="text-slate-600 text-sm leading-relaxed">
                                        <p>{INSTITUTIONAL_INFO.vision}</p>
                                    </div>
                                </div>
                            </Reveal>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default About;